import React, { useEffect, useState } from "react";
import styled from "@emotion/styled";
import {
  Box,
  Button,
  Grid,
  Stack,
  Tooltip,
  IconButton as MuiIconButton,
  Typography,
} from "@mui/material";
import { COLOR_MAP } from "../../../../constants/ColorNames";
import ConnectWithGmail from "../../../../constants/icons/ConnectWithGmail";
import { INFO_ICON } from "../../../../constants/icons/InfoIcon";
import Tick from "../../../../constants/icons/Tick";
import { INTEGRATE_MAIL_INFO_LIST } from "../../../../constants/helpers";
import { ConfigureMailDataType } from "../../../../types/dataTypes";
import Scroller from "../../../../common/components/Scroller";
import { CROSS_ICON } from "../../../../constants/icons/CrossIcon";
import { QueryStatus } from "@reduxjs/toolkit/dist/query";

const InfoText = styled.span`
  margin: 0;
  font-size: 14px;
  font-weight: 500;
`;

const IconButton = styled.a`
  cursor: pointer;
`;

const ToolTipContainer = styled(Grid)`
  padding: 0.4rem 0.8rem;
  color: ${COLOR_MAP.WHITE};
  background-color: ${COLOR_MAP.LIGHT_GREY};
  border-radius: 0.4rem;
  font-family: NOTO SANS;
`;

const TooltipText = styled.p`
  font-weight: 400;
  font-size: 1.4rem;
  line-height: 2.2rem;
  margin: 0;
`;

type ConfigureMailPropsType = {
  mailStripData: ConfigureMailDataType;
  status: QueryStatus;
  emailVerifiedData: any;
};

const MailInfo = () => {
  return (
    <Scroller
      settings={{
        dots: false,
        loop: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 1300,
        vertical: true,
      }}
    >
      {INTEGRATE_MAIL_INFO_LIST.map((info) => {
        return (
          <Stack
            sx={{
              display: "flex !important",
              gap: "4px",
              alignItems: "center",
            }}
            direction={"row"}
            alignItems={"center"}
          >
            <Tick width="18" height="18" />
            <InfoText>{info}</InfoText>
          </Stack>
        );
      })}
    </Scroller>
  );
};

const ToolTipContent = () => {
  return (
    <ToolTipContainer container>
      <TooltipText>Maximum of 500 email/day would be sent</TooltipText>
    </ToolTipContainer>
  );
};

const ConfigureMailStrip = (props: ConfigureMailPropsType) => {
  const [showStrip, setShowStrip] = useState<boolean>(false);

  const { mailStripData, status, emailVerifiedData } = props;

  const handleCloseStrip = () => {
    setShowStrip(false);
    localStorage.setItem("showStrip", "false");
  };

  useEffect(() => {
    const flag = localStorage.getItem("showStrip");

    if ((flag && flag === "true") || !flag) {
      setShowStrip(true);
    }
  }, []);

  if (!showStrip || status === "pending" || emailVerifiedData?.success) {
    return null;
  }

  return (
    <Stack
      sx={{
        backgroundColor: COLOR_MAP.CAPE_HONEY,
        padding: "0px 32px",
        height: "40px",
      }}
      alignItems="center"
      direction="row"
      justifyContent="space-between"
    >
      {mailStripData.redirectionalLink ? (
        <Stack alignItems="center" direction="row" gap={"14px"}>
          <Stack>
            <InfoText>Configure your corp email id to:</InfoText>
          </Stack>
          <Stack
            sx={{
              maxWidth: "40rem",
            }}
          >
            <MailInfo />
          </Stack>
          <Stack
            sx={{ display: "flex", flexDirection: "row", alignItems: "center" }}
            gap={1}
          >
            {mailStripData.isGmailUser ? (
              <IconButton
                href={mailStripData.redirectionalLink}
                target="_blank"
                style={{ display: "flex", alignItems: "center" }}
              >
                <ConnectWithGmail height="30" />
              </IconButton>
            ) : (
              <Button
                sx={{
                  textTransform: "capitalize",
                  p: 0.5,
                  px: 1,
                  fontSize: "14px",
                  fontWeight: 400
                }}
                href={mailStripData.redirectionalLink}
                target="_blank"
                size="small"
                variant="contained"
              >
                {" "}
                Configure Now
              </Button>
            )}

            <Tooltip title={<ToolTipContent />} arrow placement="bottom">
              <Box component="span" sx={{ mt: 0.5 }}>
                <INFO_ICON height={18} width={18} fill={COLOR_MAP.GREY_2} />
              </Box>
            </Tooltip>
          </Stack>
        </Stack>
      ) : (
        <Box sx={{ mr: 2 }}>
          <Typography sx={{ fontSize: "14px" }}>
            We have enhanced our mailbox integration offering, it is recommended
            to switch to a Gmail or Outlook-powered email ID to continue sending
            outreaches through your mailbox
          </Typography>
        </Box>
      )}

      <Stack
        sx={{ display: "flex", flexDirection: "row", alignItems: "center" }}
      >
        <MuiIconButton onClick={handleCloseStrip} sx={{ mt: 0.25 }}>
          <CROSS_ICON height={18} width={18} fill={COLOR_MAP.GREY_2} />
        </MuiIconButton>
      </Stack>
    </Stack>
  );
};

export default ConfigureMailStrip;
